// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldSelectionPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import DropDown from 'share/components/controls/Izenda.DropDown';
import actions from './Izenda.FieldSelectionPopupActions';
import connect from 'share/enhancers/Izenda.Connect';

const FieldSelectionPopup = (props: any) => {
  const localization = props.localization;
  return (
    <Popup visible onClosing={props.onClosing} autoClose={false} type='none'>
      <Popup.Header title={localization.getText('REPORTDESIGNER_LABEL_FIELD_SELECTION')} />
      <Popup.Body>
        <GridLayout className='form-horizontal'>
          <GridLayout.Row className='form-group'>
            <GridLayout.Col cols='3'>{localization.getText('COMMON_LABEL_DATA_SOURCE')}</GridLayout.Col>
            <GridLayout.Col cols='9'>
              <DropDown
                options={props.fieldQuerySourceList}
                onChange={props.onChangeDataSouce}
                value={props.selectedQuerySource.id}
                valueField='id'
                labelField='name'
              />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row className='form-group'>
            <GridLayout.Col cols='3'>{localization.getText('COMMON_LABEL_FIELD')}</GridLayout.Col>
            <GridLayout.Col cols='9'>
              <DropDown
                options={props.selectedQuerySource.fields}
                onChange={props.onChangeField}
                value={props.selectedField.name}
                valueField='name'
                labelField='name'
              />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      </Popup.Body>
      <Popup.Footer>
        <Popup.ConfirmationButton type='accept'>{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
        <Popup.ConfirmationButton type='cancel'>{localization.getText('COMMON_LABEL_CANCEL')}</Popup.ConfirmationButton>
      </Popup.Footer>
    </Popup>
  );
};

export default connect(actions)(FieldSelectionPopup);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.FieldSelectionPopup.js